import { render, staticRenderFns } from "./samplingTheImport.vue?vue&type=template&id=1689c7b6&scoped=true&"
import script from "./samplingTheImport.vue?vue&type=script&lang=js&"
export * from "./samplingTheImport.vue?vue&type=script&lang=js&"
import style0 from "./samplingTheImport.vue?vue&type=style&index=0&id=1689c7b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1689c7b6",
  null
  
)

export default component.exports